import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { cancelarCita } from "../services/citas.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaCancelar = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const cancelarCitaMutation = useMutation({
        mutationFn: cancelarCita,
        onSuccess: (cita, variables, context) => {
            if(variables.paciente !== '0'){
                queryClient.invalidateQueries({ queryKey: ['citas', variables.paciente] });
                queryClient.invalidateQueries({ queryKey: ['historialCitas', variables.paciente] });
            }
            queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
            queryClient.invalidateQueries({ queryKey: ['agendaInmunoterapia'], exact: false });
            variables.success();
            dispatch(successNotification('Cita cancelada'));
        },
        onError: (error, variables, context) => {
            variables.error();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        cancelarCitaMutation,
    }
}